//@ts-ignore
import orderReducer from './order';
import draftReducer from './draft';
import historyReducer from './history';
import typeReducer from './select-type';

const reducers = {
    transferType: typeReducer,
    transferOrder: orderReducer,
    transferDraftOrder: draftReducer,
    transferHistoryOrder: historyReducer
};

export default reducers

